import { onlineManager } from 'react-query';

const isDevelopment = process.env.NODE_ENV === 'development';

const isOnline = () => {
  return onlineManager.isOnline();
};

export { isDevelopment, isOnline };
